import { Routes, Route } from 'react-router-dom'
import { getRouterTree } from './router'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

export const Routers = () => {
    const { t } = useTranslation()
    const projectBaseData = useSelector(state => state.HeaderSlice.projectBaseData)
    const receiverTypeList = projectBaseData?.data?.receiverType
    let getRouters = routerTree => {
        return routerTree.map(({ path, element, exact, children }) => {
            if (!children) {
                return <Route exact={exact ? true : false} path={path} element={element} key={path} />
            } else {
                return (
                    <Route exact={exact ? true : false} path={path} element={element} key={path}>
                        {getRouters(children)}
                    </Route>
                )
            }
        })
    }
    return <Routes>{getRouters(getRouterTree(t, receiverTypeList))}</Routes>
}
